const MDAllyHowItWorks = (function($) {
    
    const controller = new ScrollMagic.Controller();
    const EO = Elastic.easeOut.config;
    const animation01 = $( '.animation-container .animation-01');
    const animation02 = $( '.animation-container .animation-02');
    const animation03 = $( '.animation-container .animation-03');

    let loadedItems = 0;

    const onInit = function() {

        initCanvases();
    	jQuery('body').css('opacity', 1);

    	$(window).resize( onWindowResize ).resize();
    }

    function initCanvases() {

        if( animation01.data('isReady') ) 
            initAnimation01();
        else
            animation01.data('onReady' , initAnimation01 );

        if( animation02.data('isReady') ) 
            initAnimation02();
        else
            animation02.data('onReady' , initAnimation02 );

        if( animation03.data('isReady') ) 
            initAnimation03();
        else
            animation03.data('onReady' , initAnimation03 );
    }

	function initPageScrollElements() {
	  // gsap.set( '.item04 .img01' , {objectFit:'cover' , objectFitSize:});
       // gsap.set( '.item04 .img02' , {objectFit:'cover'});

       const item01Reveal = {
            name: 'item01Reveal',
            el: '.img01 img',
            trigger: {triggerElement: '.item01' , triggerHook: 0.5 },
            gsap: $('.item01 .createjs').data('exportRoot').tl,
            pin : null,
            reverse: false,
            scene: null,
            inited : false,
            desktopOnly: false
        }
        item01Reveal.scene = MDAllyAnimations.add( item01Reveal );

        const item03Reveal = {
            name: 'item03Reveal',
            el: '.img01 img',
            trigger: {triggerElement: '.item03' , triggerHook: 0.5  },
            gsap: $('.item03 .createjs').data('exportRoot').tl,
            pin : null,
            reverse: false,
            scene: null,
            inited : false,
            desktopOnly: false
        }
        item03Reveal.scene = MDAllyAnimations.add( item03Reveal );

        /*** bottom images ***/

		const imageInner01 = {
            name: 'imageInner01',
            el: '.img01 img',
            trigger: {triggerElement: '.item04' , triggerHook: 0.8 , duration:"150%" },
            gsap: gsap.fromTo( '.img01 img' , {yPercent:10} , {yPercent:-10 , ease:'none'} ),
            pin : null,
            scene: null,
            inited : false,
            desktopOnly: true
        }
        imageInner01.scene = MDAllyAnimations.add( imageInner01 );

        const imageInner02 = {
            name: 'imageInner02',
            el: '.img02 img',
            trigger: {triggerElement: '.item04' , triggerHook: 0.8 , duration:"150%" },
            gsap: gsap.fromTo( '.img02 img' , {yPercent:-10} , {yPercent:10 , ease:'none'} ),
            pin : null,
            scene: null,
            inited : false,
            desktopOnly: true
        }
        imageInner02.scene = MDAllyAnimations.add( imageInner02 );

        const image01 = {
            name: 'image01',
            el: '.item04 .img01',
            trigger: {triggerElement: '.item04' , triggerHook: 0.8 , duration:"150%" },
            gsap: gsap.fromTo( '.item04 .img01' , {y:50} , {y:-50 , ease:Power1.easeInOut} ),
            pin : null,
            scene: null,
            inited : false,
            desktopOnly: true
        }
        image01.scene = MDAllyAnimations.add( image01 );
    

        const image02 = {
            name: 'image02',
            el: '.item04 .img02',
            trigger: {triggerElement: '.item04' , triggerHook: 0.8 , duration:"150%" },
            gsap: gsap.fromTo( '.item04 .img02' , {y:-50 } , {y:50 , ease:Power1.easeOut} ),
            pin : null,
            scene: null,
            inited : false,
            desktopOnly: true
        }
        image02.scene = MDAllyAnimations.add( image02 );

        /*** rings ***/

        $('.item').each((i,el)=>{
            const ringTL = gsap.timeline();
            ringTL.add('start', '+=0');
            ringTL.from( $(el).find('[data-name="dot"]') , 0.8 , {ease:EO(0.8,1) , scale:0 , transformOrigin:'50% 50%'} , 'start+=0' );
            ringTL.from( $(el).find('[data-name="outer-ring"]') , 0.8 , {ease:EO(0.8,1) , scale:0 , transformOrigin:'50% 50%'} , 'start+=0.3' );
            ringTL.from( $(el).find('[data-name="inner-ring"]') , 0.8 , {ease:EO(0.8,1) , scale:0 , transformOrigin:'50% 50%'} , 'start+=0.1' );

            const ring = {
                name: 'ring',
                el: el,
                trigger: {triggerElement: el , triggerHook: 0.8 },
                gsap: ringTL,
                pin : null,
                scene: null,
                inited : false,
                desktopOnly: false
            }
            ring.scene = MDAllyAnimations.add( ring );
        });

        MDAllyAnimations.update();
	}

    function initAnimation01() {
        animation01.data('exportRoot').onInit();
        console.log( animation01.data('exportRoot').ring01 );

        if( ++loadedItems == 3 ) {
            initPageScrollElements();
        }
    }

    function initAnimation02() {
        animation02.data('exportRoot').onInit();

        if( ++loadedItems == 3 ) {
            initPageScrollElements();
        }
    }

    function initAnimation03() {
        animation03.data('exportRoot').onInit();

        if( ++loadedItems == 3 ) {
            initPageScrollElements();
        }
    }

    function onWindowResize(e) {

        const t = $('.target-container.first').offset().top;
        const b = $('.target-container.last').offset().top;
        $('.target-container.first .line').height( b-t );

    }

    return {
    	init: onInit,
    }; 

})(jQuery);
